import { Reducer } from "redux";
import { InOutMarkers } from "../store";
import {
  LOAD_MARKERS,
  MarkerActionTypes,
  SET_IN_MARKER_SONG_TIME,
  SET_OUT_MARKER_SONG_TIME
} from "../actions/MarkerTypes";

export const defaultMarkerState: InOutMarkers = {
  in: {
    songTime: null
  },
  out: {
    songTime: null
  }
};

export const markersReducer: Reducer<
  InOutMarkers, MarkerActionTypes
> = (state = defaultMarkerState, action) => {
  switch (action.type) {
    case LOAD_MARKERS:
      return { ...action.markers };
    case SET_IN_MARKER_SONG_TIME:
      return {
        ...state,
        in: {
          songTime: action.songTime
        }
      };
    case SET_OUT_MARKER_SONG_TIME:
      return {
        ...state,
        out: {
          songTime: action.songTime
        }
      };
    default:
      return state;
  }
};
